import { ERentTime } from '../../../../api-models/common/json_query';

export const RENT_TIME_MAP_VALUE_TO_LABEL = {
  [ERentTime.FromYear]: 'Аренда от года',
  [ERentTime.FewMonths]: 'От нескольких месяцев',
};
